import styles from "./styles.module.scss";
import { useMemo } from "react";
import classNames from "classnames";
import { useMonetization } from "@shared";
import { useTranslation } from "react-i18next";

// const AVAILABLE_USERS_ID = [558161625, 527223923, 6716873498, 759764082, 849394687, 813969302, 264608327]

export const GetFreeItem = (props: {
  label: string;
  onClick?: () => void;
  small?: boolean;
}) => {
  const { showAd, dailyLimit } = useMonetization('tap', 'adsgram')
  const { t } = useTranslation()
  const limit = useMemo(() => {
    if (!dailyLimit) return '';
    const left = Math.max(0, dailyLimit.limit - dailyLimit.used);
    return `${left}/${dailyLimit.limit} available`;
  }, [dailyLimit]);

  const disabled = useMemo(() => {
    if (!dailyLimit) return true;
    return dailyLimit.used >= dailyLimit.limit;
  }, [dailyLimit]);


  return (
    <div className={styles.getFreeItem}>
      <button
        className={classNames(styles.getFreeItemButton, {
          [styles["getFreeItemButton__disable"]]: disabled,
          [styles["getFreeItemButton__small"]]: props.small,
        })}
        disabled={disabled}
        onClick={() => {
          showAd()
          props.onClick?.()
        }}
      >
        <span
          className={classNames(styles.text, {
            [styles["text__disable"]]: disabled,
            [styles["text__small"]]: props.small,
          })}
        >
          {disabled ? t('ad.wait') : props.label}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="23"
          height="12"
          viewBox="0 0 23 12"
          fill="none"
        >
          <path
            d="M11.75 1.7666H12.5V1.7666L11.75 1.7666ZM11.75 3.13477H11V4.26266L12.0401 3.82639L11.75 3.13477ZM14.5811 1.94727L14.291 1.25562L14.2909 1.25564L14.5811 1.94727ZM15.9678 2.86914H16.7178V2.8691L15.9678 2.86914ZM15.9678 7.59766L16.7178 7.5977V7.59766H15.9678ZM14.5811 8.51953L14.2907 9.21107L14.291 9.21118L14.5811 8.51953ZM11.75 7.33105L12.0403 6.63952L11 6.2028V7.33105H11.75ZM11.75 8.7666H12.5V8.7666H11.75ZM0.75 8.7666H4.47035e-08V8.7666H0.75ZM0.75 1.7666L4.47035e-08 1.7666V1.7666H0.75ZM1.75 0.766602V0.0166016H1.75L1.75 0.766602ZM10.75 0.766602V1.5166C10.8881 1.5166 11 1.62853 11 1.7666L11.75 1.7666L12.5 1.7666C12.5 0.800103 11.7165 0.0166016 10.75 0.0166016V0.766602ZM11.75 1.7666H11V3.13477H11.75H12.5V1.7666H11.75ZM11.75 3.13477L12.0401 3.82639L14.8712 2.63889L14.5811 1.94727L14.2909 1.25564L11.4599 2.44314L11.75 3.13477ZM14.5811 1.94727L14.8711 2.63891C15.0361 2.56971 15.2178 2.69087 15.2178 2.86918L15.9678 2.86914L16.7178 2.8691C16.7177 1.61831 15.4438 0.77219 14.291 1.25562L14.5811 1.94727ZM15.9678 2.86914H15.2178V7.59766H15.9678H16.7178V2.86914H15.9678ZM15.9678 7.59766L15.2178 7.59761C15.2178 7.77592 15.0361 7.89708 14.8711 7.82788L14.5811 8.51953L14.291 9.21118C15.4438 9.69461 16.7177 8.84848 16.7178 7.5977L15.9678 7.59766ZM14.5811 8.51953L14.8714 7.82799L12.0403 6.63952L11.75 7.33105L11.4597 8.02259L14.2907 9.21107L14.5811 8.51953ZM11.75 7.33105H11V8.7666H11.75H12.5V7.33105H11.75ZM11.75 8.7666L11 8.7666C11 8.90467 10.8881 9.0166 10.75 9.0166V9.7666V10.5166C11.7165 10.5166 12.5 9.7331 12.5 8.7666H11.75ZM10.75 9.7666V9.0166H1.75V9.7666V10.5166H10.75V9.7666ZM1.75 9.7666V9.0166C1.61193 9.0166 1.5 8.90467 1.5 8.7666H0.75H4.47035e-08C4.47035e-08 9.7331 0.783502 10.5166 1.75 10.5166V9.7666ZM0.75 8.7666H1.5V1.7666H0.75H4.47035e-08V8.7666H0.75ZM0.75 1.7666L1.5 1.7666C1.5 1.62853 1.61193 1.5166 1.75 1.5166L1.75 0.766602L1.75 0.0166016C0.783502 0.0166017 5.21541e-07 0.800104 4.47035e-08 1.7666L0.75 1.7666ZM1.75 0.766602V1.5166H10.75V0.766602V0.0166016H1.75V0.766602Z"
            fill="url(#paint0_linear_5906_18668)"
          />
          <path
            d="M8.25 4.40058C8.91667 4.78548 8.91667 5.74773 8.25 6.13263L6 7.43167C5.33333 7.81657 4.5 7.33544 4.5 6.56564L4.5 3.96756C4.5 3.19776 5.33333 2.71664 6 3.10154L8.25 4.40058Z"
            fill="url(#paint1_linear_5906_18668)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_5906_18668"
              x1="-25.75"
              y1="-31.2334"
              x2="19.0168"
              y2="-31.4617"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="1" stopColor="#7F7F7F" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_5906_18668"
              x1="-2.25"
              y1="-9.7334"
              x2="13.8365"
              y2="-5.27243"
              gradientUnits="userSpaceOnUse"
            >
              <stop />
              <stop offset="1" stopColor="#7F7F7F" />
            </linearGradient>
          </defs>
        </svg>
      </button>
      <div
        className={classNames(styles.text, {
          [styles["text__light"]]: true,
          [styles["text__disable"]]: disabled,
          [styles["text__small"]]: props.small,
        })}
      >
        {limit}
      </div>
    </div>
  );
};
